<template>
  <div class="color-gradients-content" id="identidade-visual-cores-gradientes" data-search-anchor>
    <div class="color-gradients-title-wrapper">
      <h1 class="color-gradients-title-span">{{ colorGradientsTitleSpan }}</h1>
      <h1 class="color-gradients-title">{{ colorGradientsTitle }}</h1>
    </div>
    <div class="color-gradients-title-icons-wrapper">      
      <div class="color-gradients-icon-wrapper-check">
        <IconCheck />
        <p class="color-gradients-description">{{ colorGradientsDescription }}</p>
      </div>
      
      <div class="color-gradients-icon-wrapper-cancel">              
        <p class="color-gradients-importante">{{ colorGradientsDescription2 }}</p>
        <div class="color-gradients-icon-wrapper">
          <div class="color-description-gradients-cancel">
            <IconCancel />
            <p class="color-gradients-description">{{ colorGradientsDescription3 }}</p>
          </div>
        </div>         
      </div>      
    </div>
    <div class="color-gradients-card-item" :style="{ backgroundImage: `url(${ImageSrc})` }"></div>
  </div>
</template>

<script lang="ts">
import IconCancel from '@/assets/icons/IconCancel.vue'
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import ColorPageMixin from '@/mixins/color-page-mixin'
import { ColorPageStore } from '@/store/visual-identity-page/color-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck, IconCancel } })
export default class ColorsGradientsSection extends Mixins(ColorPageMixin) {
  colorPageStore: PageStoreContract = getModule(ColorPageStore, this.$store)

  get colorGradientsTitleSpan(): string {
    return this.getElementTitle(4, 0)
  }

  get colorGradientsTitle(): string {
    return this.getElementText(4, 0)
  }

  get colorGradientsDescription(): string {
    return this.getElementText(4, 1)
  }

  get colorGradientsDescription2(): string {
    return this.getElementText(4, 2)
  }

  get colorGradientsDescription3(): string {
    return this.getElementText(4, 3)
  }

  get ImageSrc(): string {
    return this.getElementMedia(4, 4)
  }

  async getColorPage(): Promise<void> {
    await this.colorPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.colorPageStore.isLoading) {
      await this.getColorPage()
    }
  }
}
</script>

<style lang="scss">
.color-gradients-content {
  display: grid;
  max-width: 1032px;
  width: 100%;
}

.color-gradients-title-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 2rem;
}

.color-gradients-title-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;
  margin-right: 5px;
  color: #b3b3b3;
}

.color-gradients-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #000000;
}

.color-gradients-title-icons-wrapper {
  position: relative;
  display: grid;  
  grid-template-columns: 51.5% 48.5%;
  align-items: end;  
}

.color-gradients-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  width: 378px;
  padding-left: 7px;  
}

.color-gradients-icon-wrapper-check {
  display: flex;
  align-items: center;
}

.color-gradients-icon-wrapper {
  display: flex;
  align-items: center;
}

.color-gradients-card-item {
  position: relative;
  left: 0;
  max-width: 1032px;
  width: 100%;
  height: 705px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.color-gradients-importante {
  font-size: 16px;
  line-height: 20px;
  text-align: left;
  margin-top: 0;
  margin-bottom: 0;
  width: 378px;
  font-family: InterVariableBold
}
.color-description-gradients-cancel {
  display: flex;
  align-items: center;
}
</style>
